// ***************************************
// Definition of game token EndScreen
// ***************************************
import { profileManager, inventoryController, gameController, flowController } from "../../game_theme/flow_fb/flowController";
import { tbGame } from "../engine/tbGame";
import { ComponentButton } from "../framework/components/ComponentButton";
import { ComponentContainer } from "../framework/components/ComponentContainer";
import { ComponentLabel } from "../framework/components/ComponentLabel";
import { ComponentPicture } from "../framework/components/ComponentPicture";
import { ComponentSpine } from "../framework/components/ComponentSpine";
import { DialogBase } from "../framework/dialogs/DialogBase";
import { tgfHooks } from "../framework/hooks/hooks";
import { tgfAudio } from "../framework/tgfAudio";
import { tgfDictionary } from "../framework/tgfDictionary";
import { tgfGraphics } from "../framework/tgfGraphics";
import { DialogSettings, GraphicsSettings } from "../settings/Settings";
import { SoundManager } from "../settings/SoundManager";
import { AngryAnalytics } from "./Analytics/Analytics";
import { angrybirds_regular, angrybirds_regular_text } from "./AssetDefinitions/FontDefinitions";
import { s_black_square, s_bg_plain_blue, s_bg_plain_red, s_player_beams, s_button_glow2, s_ui_vignette, s_btn_green, s_btn_arrow_blue, s_icon_list, s_btn_arrow_media, s_icon_share, s_win_scorebg, s_ui_pig_green_default_main, s_ui_pig_green_scared_main, s_ui_pig_green_scared, s_ui_pig_green_default, s_win_banner, s_win_board2, s_portrait_empty, s_btn_orange, s_icon_powerup, s_powerupcount, s_confetti1_particle, s_confetti2_particle, s_confetti3_particle, s_confetti4_particle, transparent_4x4 } from "./AssetDefinitions/ImageDefinitions";
import { p_confetti } from "./AssetDefinitions/JsonDefinitions";
import { s_endScreen, s_trumpets, trophy_animation } from "./AssetDefinitions/SpineDefinitions";
import { CreateShortcutDialog } from "./LobbyCode/CreateShortcutDialog";
import { ExpRewardDialog } from "./LobbyCode/ExpRewardDialog";
import { GachaScreen } from "./LobbyCode/GachaScreen";
import { LoadingOverlay } from "./LobbyCode/LoadingOverlay";
import { NudgeFactory } from "./NudgeFactory";
import { ParticleEffect } from "./ParticleEffect";
import { playController } from "./gameController";
import { YoutubeStorageManager } from "./storage/YoutubeStorageManager";
// The constructor for the EndScreen game token. 
export var EndScreen = function (data, isInitPlayer, didWin) {
    "use strict";
    // Properties used by the engine
    this.layer = 0;
    this.visible = true;
    this.active = true;
    // Your own properties
    this.data = data;
    this.didWin = didWin;
    this.myName = "";
    this.theirName = "";
    this.topName = "";
    if (isInitPlayer) {
        this.myName = data.playerData["name"];
        this.theirName = data.opponentData["name"];
        if (didWin)
            this.topName = data.playerData["name"];
        else
            this.topName = data.opponentData["name"];
    }
    else {
        this.myName = data.playerData["name"];
        this.theirName = data.opponentData["name"];
        if (didWin)
            this.topName = data.opponentData["name"];
        else
            this.topName = data.playerData["name"];
    }
    this.myAvatar = profileManager.getInfo(data.playerData["id"]).image;
    this.theirAvatar = profileManager.getInfo(data.opponentData["id"]).image;
    this.titleText = "YOU LOSE";
    this.isInitiatingPlayer = isInitPlayer;
    this.delay = 10;
    this.startDelay = false;
    this._alphaSinProgress = 0;
    this.callback = null;
    this._callbackContext = null;
    this.configurations = {
        PRACTICE: {
            hasSideButtons: false,
            hasShareButon: false,
            hasPowerupRefillButton: false,
            buttonRematchX: 0,
            rematchButtonCallback: this.toLobby.bind(this),
            hasRematchButton: true,
            videoContainerX: 0,
            buttonLeftX: 500,
            buttonRightX: -344,
        },
        WITH_REMATCH: {
            hasSideButtons: true,
            hasShareButon: false,
            hasPowerupRefillButton: false,
            buttonRematchX: 251,
            rematchButtonCallback: this.sendRematch.bind(this),
            hasRematchButton: true,
            videoContainerX: -251,
            buttonLeftX: 500,
            buttonRightX: -344,
        },
        WITHOUT_REMATCH: {
            hasSideButtons: true,
            hasShareButon: false,
            hasPowerupRefillButton: false,
            buttonRematchX: 0,
            rematchButtonCallback: this.toLobby.bind(this),
            hasRematchButton: false,
            videoContainerX: 0,
            buttonLeftX: 500,
            buttonRightX: -344,
        }
    };
    // Add it to the game engine
    tbGame.addToken(this);
};
// handleAdd is called when the token is (re-) added to the game. 
EndScreen.prototype.handleAdd = function () {
    "use strict";
    AngryAnalytics.reportScreen("endscreen");
    var self = this;
    this._setupVersionDifferences();
    tgfAudio.stop("music");
    SoundManager.mutedPigs = true;
    var animation = "s_birds_lose_animation";
    var stinger = SoundManager.MUSIC_STATE.STINGER_LOSE;
    if (this.didWin) {
        animation = "s_birds_win_animation";
        stinger = SoundManager.MUSIC_STATE.STINGER_WIN;
    }
    SoundManager.playEffect(stinger, SoundManager.MusicCollection, 0, false);
    var LEFT_PLAYER_NAME = this.isInitiatingPlayer ? this.myName : this.theirName;
    var RIGHT_PLAYER_NAME = this.isInitiatingPlayer ? this.theirName : this.myName;
    if (typeof LEFT_PLAYER_NAME === 'undefined') {
        LEFT_PLAYER_NAME = 'UNKNOWN';
    }
    if (typeof RIGHT_PLAYER_NAME === 'undefined') {
        RIGHT_PLAYER_NAME = 'UNKNOWN';
    }
    var LEFT_PLAYER_IMAGE = this.isInitiatingPlayer ? this.myAvatar : this.theirAvatar;
    var RIGHT_PLAYER_IMAGE = this.isInitiatingPlayer ? this.theirAvatar : this.myAvatar;
    this.dialog = new DialogBase({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    ;
    this.transparentBlack = new ComponentButton({
        x: -100,
        y: -100,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 60,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 60,
        alpha: 0.7,
        image: s_black_square
    });
    this.dialog.addComponent(this.transparentBlack);
    var background = new ComponentPicture({
        image: this.didWin ? s_bg_plain_blue : s_bg_plain_red,
        createFromSlices: true,
        sliceMarginsArray: [20, 20, 20, 20],
        width: tgfGraphics.areaWidth,
        height: tgfGraphics.areaHeight,
        x: -(tgfGraphics.areaWidth * 0.5),
        y: -(tgfGraphics.areaHeight * 0.5)
    });
    if (this.didWin) {
        this.bgPlayerBeams = new ComponentPicture({
            xScale: 4,
            yScale: 4,
            alpha: 0.5,
            x: tgfGraphics.areaWidth * 0.50,
            y: tgfGraphics.areaHeight * 0.50,
            image: s_player_beams
        });
    }
    else {
        this.bgPlayerBeams = new ComponentPicture({
            xScale: 8,
            yScale: 8,
            x: tgfGraphics.areaWidth * 0.50,
            y: tgfGraphics.areaHeight * 0.50,
            image: s_button_glow2
        });
    }
    this.bgVignette = new ComponentPicture({
        xScale: 4.05,
        yScale: 4.05,
        x: 0,
        y: 0,
        alpha: this.didWin ? 0.55 : 1,
        image: s_ui_vignette
    });
    background.addComponent(this.bgPlayerBeams);
    background.addComponent(this.bgVignette);
    this.dialog.addComponent(background);
    var spine = new ComponentSpine({
        spineAnimation: s_endScreen,
        animationClip: animation,
        x: 0,
        y: 230,
        scale: 0.8,
        repeat: true
    });
    this.dialog.addComponent(spine);
    if (this.didWin) {
        this.trumpetLeft = new ComponentSpine({
            x: -700,
            y: 170,
            xScale: 11.6,
            yScale: 11.6,
            spineAnimation: s_trumpets,
            animationClip: "s_trumpets_start_animation",
            repeat: false,
            onComplete: function () {
                self.startDelay = true;
            }
            // onEvent: function(component){
            //    self.startDelay = true;
            // }
        });
        this.dialog.addComponent(this.trumpetLeft);
        this.trumpetRight = new ComponentSpine({
            spineAnimation: s_trumpets,
            x: 700,
            y: 170,
            xScale: 11.6,
            yScale: 11.6,
            animationClip: "s_trumpets_start_animation",
            repeat: false,
            flip: true
        });
        this.dialog.addComponent(this.trumpetRight);
    }
    var headingFont = {
        fontFace: angrybirds_regular.fontFace,
        fillColor: "#fefefe",
        align: "center",
        baseline: "middle",
        fontSize: 45,
        shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 4 } //{active: true, distance: 4, angle: 0, offsetX: 4, offsetY: 4, alpha:0.1, blur: 7},
    };
    var yButtons = (tgfGraphics.areaHeight / 2 - 20 - s_btn_green.height / 2);
    this.buttonRematch = new ComponentButton({
        image: s_btn_green,
        x: this.buttonRematchX,
        y: yButtons,
        onClick: function (comp) {
            self.rematchButtonCallback();
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
        }
    });
    if (this.hasRematchButton) {
        this.dialog.addComponent(this.buttonRematch);
    }
    this.buttonRematchText = new ComponentLabel({
        text: playController.getRematchBtnText(),
        font: headingFont,
        align: "center",
        x: 0,
        y: 0
    });
    this.buttonRematch.addComponent(this.buttonRematchText);
    if (this.hasSideButtons) {
        this.buttonRight = new ComponentButton({
            image: s_btn_arrow_blue,
            icon: s_icon_list,
            iconPosition: "center",
            x: this.buttonRightX,
            y: 51 + yButtons - s_btn_arrow_blue.height / 2,
            onClick: function () {
                self.toLobby.call(self);
                SoundManager.playEffect(SoundManager.UI_STATE.BACK, SoundManager.UICollection, 0, false);
            }
        });
        this.dialog.addComponent(this.buttonRight);
        if (this.hasShareButton) {
            this.buttonLeft = new ComponentButton({
                image: s_btn_arrow_media,
                x: this.buttonLeftX,
                y: 51 + yButtons - s_btn_arrow_media.height / 2,
                xScale: -1,
                onClick: function () {
                    AngryAnalytics.reportShareClicked();
                    self.buttonLeft.deactivate();
                    self.buttonLeft.hide();
                    self.loadShareOverlay.show();
                    self.sendNotification();
                    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
                }
            });
            this.dialog.addComponent(this.buttonLeft);
            var buttonLeftIcon = new ComponentPicture({
                image: s_icon_share,
                x: -s_btn_arrow_media.width
            });
            this.buttonLeft.addComponent(buttonLeftIcon);
        }
    }
    //var image = tgfHooks.getProfileImage();
    this.winBoardLeft = new ComponentPicture({
        image: s_win_scorebg,
        xScale: 1,
        yScale: 1,
        x: 2,
        y: -135
    });
    var pigCounterText = "";
    if (this.isInitiatingPlayer) {
        pigCounterText = ((this.data.playerData.totalPigs.toString()) + " - " + (this.data.opponentData.totalPigs.toString()));
    }
    else {
        pigCounterText = ((this.data.opponentData.totalPigs.toString()) + " - " + (this.data.playerData.totalPigs.toString()));
    }
    this.pigCount = new ComponentLabel({
        text: pigCounterText,
        xScale: 1,
        yScale: 1,
        font: {
            fontFace: angrybirds_regular.fontFace,
            fontSize: 51,
            fillColor: "white",
            align: "center",
            padding: 10,
            baseline: "middle",
            fontStyle: 'italic'
        },
        x: -5,
        y: -27
    });
    this.winBoardLeft.addComponent(this.pigCount);
    this.progressPigLeft = new ComponentPicture({
        image: this.didWin ? s_ui_pig_green_default_main : s_ui_pig_green_scared_main,
        width: 60,
        height: 60,
        xScale: -0.5,
        yScale: 0.5,
        x: -105,
        y: -12
    });
    this.winBoardLeft.addComponent(this.progressPigLeft);
    this.progressPigRight = new ComponentPicture({
        image: this.didWin ? s_ui_pig_green_scared : s_ui_pig_green_default,
        width: 60,
        height: 60,
        xScale: 0.5,
        yScale: 0.5,
        x: 105,
        y: -12
    });
    this.winBoardLeft.addComponent(this.progressPigRight);
    this.bannerLeft = new ComponentPicture({
        image: s_win_banner,
        xScale: 1,
        yScale: 1,
        x: 2,
        y: -65
    });
    headingFont.shadow.active = false;
    headingFont.fontSize = 80;
    this.playerNameHeader = new ComponentLabel({
        font: headingFont,
        align: "center",
        fontStyle: 'bold',
        x: 0,
        y: -55,
        fitToBox: true,
        width: 500,
        height: 125,
        text: this.topName
    });
    this.plankHeading = new ComponentPicture({
        image: s_win_board2,
        xScale: 1,
        yScale: 1,
        x: 0,
        y: -128
    });
    this.plankHeadingText = new ComponentLabel({
        text: tgfDictionary.getText("WINNER_HEADER"),
        xScale: 1,
        yScale: 1,
        font: {
            fontFace: angrybirds_regular_text.fontFace,
            fontSize: 32,
            fillColor: "#fefefe",
            align: "center",
            padding: 10,
            baseline: "middle",
            fontStyle: 'italic'
        },
        x: 0,
        y: -4
    });
    var leftProfileScale = profileManager.scaler(LEFT_PLAYER_IMAGE, 320 * 0.44);
    this.leftAvatar = new ComponentPicture({
        image: LEFT_PLAYER_IMAGE,
        xScale: leftProfileScale,
        yScale: leftProfileScale,
        angle: -0.25,
        x: -415,
        y: 25
    });
    var rightProfileScale = profileManager.scaler(RIGHT_PLAYER_IMAGE, 320 * 0.44);
    this.rightAvatar = new ComponentPicture({
        image: RIGHT_PLAYER_IMAGE,
        xScale: rightProfileScale,
        yScale: rightProfileScale,
        angle: 0.25,
        x: 407,
        y: 25
    });
    this.leftAvatarFrame = new ComponentPicture({
        image: s_portrait_empty,
        xScale: 1,
        yScale: 1,
        angle: -0.25,
        x: 0,
        y: 0
    });
    this.rightAvatarFrame = new ComponentPicture({
        image: s_portrait_empty,
        xScale: -1,
        yScale: 1,
        angle: 0.25,
        x: 0,
        y: 0
    });
    if (playController.canAddScoreToLeaderboard()) {
        if (this.didWin) {
            this.trophyLeft = new ComponentSpine({
                x: 15,
                y: 180,
                spineAnimation: trophy_animation,
                animationClip: "trophy_bounceanimation",
                repeat: true,
                flip: true
            });
            this.scoreLeft = new ComponentLabel({
                text: '+' + (this.isInitiatingPlayer ? this.data.playerData.totalPigs.toString() : this.data.opponentData.totalPigs.toString()),
                xScale: 1,
                yScale: 1,
                font: DialogSettings.textFont,
                x: 0,
                y: -5
            });
            this.scoreLeft.font.fillColor = '#181818';
            this.scoreLeft.font.shadow.active = false;
            this.trophyLeft.addComponent(this.scoreLeft);
            this.leftAvatarFrame.addComponent(this.trophyLeft);
        }
        else {
            this.trophyRight = new ComponentSpine({
                x: -15,
                y: 180,
                spineAnimation: trophy_animation,
                animationClip: "trophy_bounceanimation",
                repeat: true
            });
            this.scoreRight = new ComponentLabel({
                text: '+' + (this.isInitiatingPlayer ? this.data.opponentData.totalPigs.toString() : this.data.playerData.totalPigs.toString()),
                xScale: 1,
                yScale: 1,
                font: DialogSettings.textFont,
                x: 0,
                y: -5
            });
            this.scoreRight.font.fillColor = '#181818';
            this.scoreRight.font.shadow.active = false;
            this.trophyRight.addComponent(this.scoreRight);
            this.rightAvatarFrame.addComponent(this.trophyRight);
        }
    }
    this.nameLeft = new ComponentLabel({
        text: LEFT_PLAYER_NAME,
        xScale: 1,
        yScale: 1,
        font: DialogSettings.textFont,
        x: 17,
        y: 118
    });
    this.nameRight = new ComponentLabel({
        text: RIGHT_PLAYER_NAME,
        font: DialogSettings.textFont,
        x: -17,
        y: 118
    });
    if (this.hasPowerupRefillButton) {
        this.videoContainer = new ComponentContainer({
            x: this.videoContainerX,
            y: yButtons - 4
        });
        this.dialog.addComponent(this.videoContainer);
        this.watchVideoText = new ComponentLabel({
            text: tgfDictionary.getText("BTN_REFILL_POWERUPS"),
            font: DialogSettings.buttonFont,
            x: 0,
            y: 0,
            fitToBox: true,
            width: s_btn_orange.width * 0.7,
            height: s_btn_orange.height
        });
        this.watchVideo = new ComponentButton({
            image: s_btn_orange,
            onClick: function () {
                SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
                self.dialog.hide();
                self.gachaScreen = new GachaScreen(function () {
                    self.powerPlusText.setText(inventoryController.getFilledPowerUps().toString());
                    self.dialog.show();
                }, true);
            }
        });
        this.watchVideo.addComponent(this.watchVideoText);
        this.videoContainer.addComponent(this.watchVideo);
        var videoIcon = new ComponentPicture({
            image: s_icon_powerup,
            x: this.watchVideo.image.width / 2 - 50,
            xScale: 0.8,
            yScale: 0.8
        });
        this.videoContainer.addComponent(videoIcon);
        var powerPlus = new ComponentPicture({
            x: s_btn_orange.width / 2 - s_powerupcount.width / 2 + 5,
            y: s_btn_orange.height / 2 - s_powerupcount.width / 2 + 5,
            xScale: 1.2,
            yScale: 1.2,
            image: s_powerupcount
        });
        this.videoContainer.addComponent(powerPlus);
        this.powerPlusText = new ComponentLabel({
            y: -4,
            text: inventoryController.getFilledPowerUps().toString(),
            font: {
                fontFace: angrybirds_regular.fontFace,
                fontSize: 36,
                align: "center",
                baseline: "middle",
                fillColor: "#531c01",
                fontStyle: 'bold',
                shadow: { active: false }
            }
        });
        powerPlus.addComponent(this.powerPlusText);
    }
    this.leftAvatar.addComponent(this.leftAvatarFrame);
    this.rightAvatar.addComponent(this.rightAvatarFrame);
    this.bannerLeft.addComponent(this.rightAvatar);
    this.bannerLeft.addComponent(this.leftAvatar);
    this.leftAvatarFrame.addComponent(this.nameLeft);
    this.rightAvatarFrame.addComponent(this.nameRight);
    this.bannerLeft.addComponent(this.playerNameHeader);
    this.plankHeading.addComponent(this.plankHeadingText);
    this.bannerLeft.addComponent(this.plankHeading);
    this.winBoardLeft.addComponent(this.bannerLeft);
    this.dialog.addComponent(this.winBoardLeft);
    this.dialog.show();
    if (this.didWin) {
        this.particle = new ParticleEffect(-tgfGraphics.areaWidth / 2, -tgfGraphics.areaHeight / 2, { particle: p_confetti, images: [s_confetti1_particle, s_confetti2_particle, s_confetti3_particle, s_confetti4_particle], scale: 2 }, this.dialog.baseContainer);
    }
    this.loadShareOverlay = new LoadingOverlay({
        text: "WAIT_TEXT",
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        autoCloseDelay: 10000,
        onError: function () {
            self.loadShareOverlay = null;
        }
    });
    this.loader = new LoadingOverlay({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this.inputMask = new DialogBase();
    this.inputMask.addComponent(new ComponentButton({
        image: transparent_4x4,
        xScale: 1000000,
        yScale: 1000000,
        x: -1000,
        y: -1000,
    }));
    this.inputMask.show();
    if (flowController.shouldShowShortcutRequestNextMatch && this.didWin) {
        tgfHooks.canCreateShortcut().then(function (canCreateShortcut) {
            if (canCreateShortcut) {
                var dialog = new CreateShortcutDialog({
                    onClose: self.afterShortcutRequest.bind(self)
                });
                dialog.show();
            }
            else {
                self.afterShortcutRequest(false);
            }
        });
    }
    else {
        self.afterShortcutRequest(false);
    }
    setTimeout(function () {
        var expDialog = new ExpRewardDialog({
            didWin: self.didWin,
            onClose: self.toggleButtons.bind(self, true),
        });
        expDialog.show();
        expDialog.afterShow();
    }, 1000);
    this.toggleButtons(false);
};
EndScreen.prototype.toggleButtons = function (show) {
    if (show) {
        if (this.hasRematchButton) {
            this.buttonRematch.show();
            this.buttonRematch.activate();
        }
        if (this.hasSideButtons) {
            this.buttonRight.show();
            this.buttonRight.activate();
            if (this.hasShareButton) {
                this.buttonLeft.show();
                this.buttonLeft.activate();
            }
        }
        if (this.hasPowerupRefillButton) {
            this.videoContainer.show();
            this.videoContainer.activate();
        }
    }
    else {
        if (this.hasRematchButton) {
            this.buttonRematch.hide();
        }
        if (this.hasSideButtons) {
            this.buttonRight.hide();
            if (this.hasShareButton) {
                this.buttonLeft.hide();
            }
        }
        if (this.hasPowerupRefillButton) {
            this.videoContainer.hide();
        }
    }
};
EndScreen.prototype._setupVersionDifferences = function () {
    if (playController.isAI && !playController.isFake) {
        this._applySettings(this.configurations.PRACTICE);
    }
    else if (playController.canRematch()) {
        this._applySettings(this.configurations.WITH_REMATCH);
    }
    else {
        this._applySettings(this.configurations.WITHOUT_REMATCH);
    }
};
EndScreen.prototype._applySettings = function (settings) {
    for (var setting in settings) {
        this[setting] = settings[setting];
    }
};
EndScreen.prototype.afterShortcutRequest = function (shouldUpdateCount) {
    this.inputMask.hide();
    flowController.shouldShowShortcutRequestNextMatch = false;
    if (!shouldUpdateCount) {
        return;
    }
    YoutubeStorageManager.getPlayerData(["shortcutRequestCount"], function (data) {
        var count = data["shortcutRequestCount"] || 0;
        count++;
        YoutubeStorageManager.savePlayerData(["shortcutRequestCount"], [count], function () {
            console.log("saved shortcut creation requests: " + count);
        }, function (error) {
            console.log(error);
        });
    });
};
EndScreen.prototype.sendRematch = function () {
    AngryAnalytics.reportClickedRematchInResultScreen();
    SoundManager.playEffect(SoundManager.UI_STATE.ENTER_GAME, SoundManager.UICollection, 0, false);
    if (this.callback) {
        this.callback.call(this._callbackContext);
    }
    tbGame.removeToken(this);
};
EndScreen.prototype.toLobby = function () {
    AngryAnalytics.reportClickedLobbyInResultScreen();
    SoundManager.playEffect(SoundManager.UI_STATE.BACK, SoundManager.UICollection, 0, false);
    gameController.stopPlay();
    this.callback = null;
    tbGame.removeToken(this);
};
// handleRemove is called when the token is removed from the game.
EndScreen.prototype.handleRemove = function () {
    "use strict";
    SoundManager.mutedPigs = false;
    if (this.gachaScreen) {
        tbGame.removeToken(this.gachaScreen);
    }
    this.dialog.hide();
    this.dialog.free();
    if (this.particle) {
        tbGame.removeToken(this.particle);
    }
};
EndScreen.prototype.setCallback = function (call, context) {
    "use strict";
    if (call && context) {
        this.callback = call;
        this._callbackContext = context;
    }
    else {
        console.log("Something is missing setting this callback");
    }
};
// handleBeginStep is called each step before processing other events.
EndScreen.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    if (this.startDelay) {
        this.delay -= timePassed;
        if (this.delay < 0 && this.trumpetLeft) {
            this.trumpetLeft.repeat = true;
            this.trumpetRight.repeat = true;
            this.trumpetLeft.setAnimation("s_trumpets_loop_animation");
            this.trumpetRight.setAnimation("s_trumpets_loop_animation");
            this.startDelay = false;
        }
    }
    if (this.didWin)
        this.bgPlayerBeams.setAngle(this.bgPlayerBeams.angle + 0.005 * GraphicsSettings.winScreenBGRotationSpeed);
    if (!this.didWin) {
        this.bgVignette.setAlpha(((Math.sin(this._alphaSinProgress += (timePassed * 0.002))) * 0.18 // magic numbers
        ) + 0.5);
    }
};
EndScreen.prototype.sendNotification = function () {
    "use strict";
    var self = this;
    this.winData = null;
    this.loseData = null;
    if (this.didWin) {
        this.winData = this.isInitiatingPlayer ? playController.sharedData["initiatingPlayerData"] : playController.sharedData["otherPlayerData"];
        this.loseData = this.isInitiatingPlayer ? playController.sharedData["otherPlayerData"] : playController.sharedData["initiatingPlayerData"];
    }
    else {
        this.winData = this.isInitiatingPlayer ? playController.sharedData["otherPlayerData"] : playController.sharedData["initiatingPlayerData"];
        this.loseData = this.isInitiatingPlayer ? playController.sharedData["initiatingPlayerData"] : playController.sharedData["otherPlayerData"];
    }
    var winnerFirstName = profileManager.getFirstName(this.winData["id"]);
    var loserFirstName = profileManager.getFirstName(this.loseData["id"]);
    var shareImage = Math.ceil(2 * Math.random());
    var endMsg = NudgeFactory.GetPremadeNudge("share", shareImage, {
        winData: this.winData,
        loseData: this.loseData,
        winnerFirstName: winnerFirstName,
        loserFirstName: loserFirstName,
        canAddScore: playController.canAddScoreToLeaderboard()
    });
    if (tgfHooks.share) {
        tgfHooks.share(function () {
            if (self.loadShareOverlay) {
                self.loadShareOverlay.hide();
                self.loadShareOverlay.free();
                self.loadShareOverlay = null;
            }
        }, "SHARE", endMsg, String.format(tgfDictionary.getText('SHARE_TEXT'), winnerFirstName, loserFirstName), { "tag": "custom_share" }, function () { });
    }
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
EndScreen.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
EndScreen.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
};
// handleAlarm is called if a global alarm is reached.
EndScreen.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
EndScreen.prototype.handleSpecial = function (id, args) {
    "use strict";
};
// handleEndStep is called each step after processing other events (before draw).
EndScreen.prototype.handleEndStep = function (timePassed) {
    "use strict";
};
// handleDraw is called at the end of a step to draw the token.
EndScreen.prototype.handleDraw = function () {
    "use strict";
};
